<template>
  <div class="layout">
    <Layout>
      <div @mousewheel="rollScroll($event)">
        <el-carousel
          height="100vh"
          direction="vertical"
          trigger="click"
          :autoplay="false"
          ref="carousel"
          @mousewheel="rollScroll($event)"
        >
          <el-carousel-item>
            <Header>
              <Menu mode="horizontal" theme="dark" active-name="0">
                <div class="layout-logo" style="display: flex;align-items: center;margin-left: 30px;">
                  <img src="../assets/freight.png" alt="" />
                  <div style="color:#23326E;font-size:25px;font-weight: bold;letter-spacing: 1px;margin-left: 10px;font-family: inherit;">通达云新能源科技(河南)有限公司</div>
                </div>
                <div class="layout-nav">
                  <MenuItem
                    style="font-size: 18px !important"
                    name="1"
                    to="/sourceInformation"
                  >
                    货源信息
                  </MenuItem>

                  <MenuItem
                    to="/vehicleInformation"
                    style="font-size: 18px !important"
                    name="2"
                  >
                    车源信息
                  </MenuItem>
                  <MenuItem
                    to="/complaintPublicity"
                    style="font-size: 18px !important"
                    name="3"
                  >
                    评价公示
                  </MenuItem>
                  <MenuItem
                    to="/evaluationPublicity"
                    style="font-size: 18px !important"
                    name="4"
                  >
                    投诉公示
                  </MenuItem>
                  <Submenu name="5">
                    <template slot="title"
                      ><span style="font-size: 18px !important">联系客服</span>
                    </template>
                    <MenuItem
                      to="/customerServiceContact"
                      style="
                        font-size: 15px !important;
                        padding-left: 35px !important;
                      "
                      name="2-1"
                      >投诉建议</MenuItem
                    >
                    <MenuItem
                      to="/contactUs"
                      style="
                        font-size: 15px !important;
                        padding-left: 35px !important;
                      "
                      name="2-2"
                      >联系我们</MenuItem
                    >
                  </Submenu>
                  <MenuItem
            to=""
            target="_blank"
              style="font-size: 18px !important"
              name="6"
            >
              登录
            </MenuItem>
                </div>
              </Menu>
            </Header>
            <!--  -->
            <Content>
              <div>
                <!-- 轮播图 -->
                <div>
                  <el-row>
                    <el-col>
                      <el-carousel height="100vh" v-model="value1" loop>
                         <el-carousel-item>
                          <div class="demo-carousel">
                            <img
                              style="width: 100%; height: 100%"
                              src="../assets/ban/1.png"
                              alt=""
                            />
                            <div class="dix-tilei">
                              <div class="tilei-css">
                                高效的运输管理系统
                              </div>
                              <div class="tilei-css2">
                                安全、可靠、让您发货无忧
                              </div>
                            </div>
                          </div>
                        </el-carousel-item> 
                        <el-carousel-item>
                          <div class="demo-carousel">
                            <img
                              style="width: 100%; height: 100%"
                              src="../assets/ban/2.png"
                              alt=""
                            />
                          </div>
                            <div class="dix-tilei">
                              <div class="tilei-css">
                                多种产品形态，多种终端覆盖
                              </div>
                              <div class="tilei-css2">
                              让每一次操作更加便捷
                              </div>
                            </div>
                        </el-carousel-item> 
                      <el-carousel-item>
                          <div class="demo-carousel">
                            <img
                              style="width: 100%; height: 100%"
                              src="../assets/ban/5.png"
                              alt=""
                            />
                          </div>
                             <div class="dix-tilei">
                              <div class="tilei-css">
                                强大的运力组织及调度能力
                              </div>
                              <div class="tilei-css2">
                              让每一次运输更效、快捷
                              </div>
                            </div>
                        </el-carousel-item> 
                        <el-carousel-item>
                          <div class="demo-carousel">
                            <img
                              style="width: 100%; height: 100%"
                              src="../assets/ban/2.png"
                              alt=""
                            />
                          </div>
                          <div class="dix-tilei">
                            <div class="tilei-css">
                              灵活的对账结算体系
                            </div>
                            <div class="tilei-css2">
                              支持实时、账期等多种结算方式
                            </div>
                          </div>
                        </el-carousel-item>
                      </el-carousel>
                    </el-col>
                  </el-row>

                  <!-- <div class="box-bottom">
                    <div class="box-weight">1</div>
                    <div class="box-weight">2</div>
                    <div  class="box-weight">3</div>
                    <div  class="box-weight">4</div>
                  </div> -->

                  <!-- 数量 -->
                  <div class="main-content">
                    <div
                      style="
                        border: solid #3e4551 1px;
                        width: 100%;
                        display: flex;
                      "
                    >
                      <div class="box-weight">
                        <div class="main-content-text">
                          <div style="display: flex">
                            <div style="margin-left: 10px">
                              <i
                                class="
                                  iconfont
                                  icon-huozhuguanli
                                  main-content-icon
                                "
                              ></i>
                            </div>
                            <div class="main-content-size">
                              <p class="main-content-size1">平台货主</p>
                              <p class="main-content-num">
                                {{ homeData.cargoOwner }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="box-weight">
                        <div class="main-content-text-left">
                          <div style="display: flex">
                            <div style="margin-left: 10px">
                              <i
                                class="
                                  iconfont
                                  icon-sijixinxiguanli
                                  main-content-icon
                                "
                              ></i>
                            </div>
                            <div class="main-content-size">
                              <p class="main-content-size1">平台司机</p>
                              <p class="main-content-num">
                                {{ homeData.driver }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="box-weight">
                        <div class="main-content-text-left">
                          <div style="display: flex">
                            <div style="margin-left: 10px">
                              <i
                                class="
                                  iconfont
                                  icon-cheliangxinxiguanli
                                  main-content-icon
                                "
                              ></i>
                            </div>
                            <div class="main-content-size">
                              <p class="main-content-size1">平台车辆</p>
                              <p class="main-content-num">
                                {{ homeData.vehicle }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="box-weight">
                        <div class="main-content-text-left">
                          <div style="display: flex">
                            <div style="margin-left: 10px">
                              <i
                                class="iconfont icon-yundan main-content-icon"
                              ></i>
                            </div>
                            <div class="main-content-size">
                              <p class="main-content-size1">本月运单</p>
                              <p class="main-content-num">
                                {{ homeData.waybill }}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="box-weight">
                        <div class="main-content-text-left">
                          <div style="display: flex">
                            <div style="margin-left: 10px">
                              <i
                                class="
                                  iconfont
                                  icon-zhongliang
                                  main-content-icon
                                "
                              ></i>
                            </div>
                            <div class="main-content-size">
                              <p class="main-content-size1">本月运量</p>
                              <div class="main-content-num">
                                <span id="countup3">{{
                                  homeData.freightVolume
                                }}</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </Content>
          </el-carousel-item>
          <el-carousel-item>
            <!--  -->
            <div class="Footer-layout-img">
              <Footer class="layout-footer-center">
                <div
                  style="
                    width: 100%;
                    height: 900%;
                    background-image: linear-gradient(#252c37, #1e252c);
                  "
                >
                
                  <div>
                    <div style="width: 100%; height: 100vh">
                      <img
                        style="width: 100%; height: 100%; z-index: 1"
                        src="../assets/bg.png"
                        alt=""
                        srcset=""
                      />
                    </div>
                    <div class="Footer-img">
                      
                      <div style="display: flex">
                        <!-- <div>
                          <div class="Footer-img1">
                            <img
                              style="width: 100%; height: 100%"
                              src="../assets/official.jpg"
                              alt=""
                            />
                          </div>
                          <div class="Footer-img-size">微信公众号</div>
                          <div class="Footer-img-but">扫码关注</div>
                        </div> -->
                        <div>
                          <div>
                            <div class="Footer-img2">
                              <img
                                style="width: 100%; height: 100%"
                                src="../assets/app/5555.png"
                                alt=""
                              />
                            </div>
                            <div class="Footer-img2-size">用户APP</div>
                            <div class="Footer-img2-but">扫码下载</div>
                          </div>
                        </div>
                        <div class="img
                        
                        ">
                        </div>

                        <div class="Footer-img-app">
                          <div class="app-div">
                            <img class="app-img" src="../assets/app/1111.jpg" alt="">
                          </div>
                          <div class="app-div">
                            <img class="app-img" src="../assets/app/2222.jpg" alt="">
                          </div>
                          <div class="app-div">
                            <img class="app-img" src="../assets/app/3333.jpg" alt="">
                          </div>
                          <div class="app-div">
                            <img class="app-img" src="../assets/app/4444.jpg" alt="">
                          </div>
                           <div class="app-div">
                            <img class="app-img" src="../assets/app/5555.jpg" alt="">
                          </div>
                           <div class="app-div">
                            <img class="app-img" src="../assets/app/6666.jpg" alt="">
                          </div>
                           
                        </div>

                      </div>
                     
                    </div>

                  </div>

                  <!-- 低 -->
                  <div style="display: flex; margin-top: -320px; z-index: 999">
                    <div class="Footer-text-left">
                      通达云网络货运平台欢迎您的加入！
                    </div>
                    <div class="Footer-text-right">
                      <p class="Footer-text-title">通达云新能源科技(河南)有限公司</p>
                      <!-- <p class="opt opt-let">
                        <span class="title">帮助中心</span> -->
                        <!-- <a class="a-link" href="#">用户指南</a> -->
                        <!-- <router-link class="a-link" :to="'/userGuide'">
                          用户指南
                        </router-link>
                      </p> -->
                      <p class="opt opt-let">
                        <span class="title">关于我们</span>
                        <router-link class="a-link" :to="'/contactUs'">
                          联系我们
                        </router-link>
                      </p>
                      <p class="opt opt-let2">
                        <span style="margin-left: -1px" class="title"
                          >服务热线</span
                        >
                        <router-link class="a-link1" :to="'#'">
                          19103971555
                        </router-link>
                      </p>
                      <!-- <div class="opt opt-let">
                        <span style="color: #b4c1cd; font-size: 16px"
                          >服务热线</span
                        >
                        <span
                          style="
                            font-size: 16px;
                            color: #ffffff;
                            margin-left: 10px;
                          "
                          >19103971555</span
                        >
                      </div> -->
                      <!-- <p class="opt opt-let2">
                        
                      </p> -->
                    </div>
                  </div>
                  <!-- 线 -->
                  <div class="Line">
                    <div class="LineClik"></div>
                  </div>
                  <!-- 低 -->
                  <div>
                    <p style="line-height: 18px">
                      <img
                        src="../assets/hui.png"
                        style="
                          width: 18px;
                          height: 18px;
                          vertical-align: middle;
                        "
                        alt=""
                      />
                      <a
                        style="line-height: 18px; color: #ffffff"
                        href="http://www.beian.gov.cn/portal/recordQuery?token=cc5dd992-aa8e-47e8-94b8-2c2e2feadf98"
                        target="_blank"
                        >豫公网安备41010039082-24001号</a
                      >&emsp;
                      <span style="color: #b4c1cd"
                        >增值电信业务经营许可证：</span
                      >
                      <a
                        href="https://beian.miit.gov.cn/#/Integrated/index"
                        style="line-height: 18px; color: #ffffff"
                        target="_blank"
                        >豫B2-20241188</a
                      >
                    </p>
                    <p style="padding-bottom: 20px; color: #b4c1cd">
                      © Copyright 2026
                      <span
                        ><a style="color: #ffffff" href="contactUs">
                          通达云新能源科技(河南)有限公司
                        </a></span
                      >
                      All Rights Reserved.
                      <a
                        style="color: #ffffff"
                        href="https://beian.miit.gov.cn/#/Integrated/index"
                        target="_blank"
                        >豫ICP备2024084587号</a
                      >
                    </p>
                    <div>
                      <div style="width: 100%; height: 10000px"></div>
                    </div>
                  </div>
                </div>
              </Footer>
            </div>
          </el-carousel-item>
        </el-carousel>
      </div>
    </Layout>
  </div>
</template>
<script>
// import {evaluateList} from "../api/api";
export default {
  data() {
    return {
      value1: 0,
      height: 0,
      one: false,
      homeData: {},
    };
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      this.$axios({
        method: "post",
        url: "/freight/officialWebsiteData/homePageStatistics",
      }).then((res) => {
        this.homeData = res.data.result;
        this.homeData.freightVolume = parseFloat(
          this.homeData.freightVolume
        ).toFixed(2);
      });
    },
    //滚动
    rollScroll(event) {
      let _that = this;
      // chrome、ie使用的wheelDelta，火狐使用detail
      let scrollVal = event.wheelDelta || event.detail;
      // 节流
      if (!_that.timeOut) {
        _that.timeOut = setTimeout(() => {
          _that.timeOut = null;
          scrollVal > 0
            ? _that.$refs.carousel.prev()
            : _that.$refs.carousel.next();
        }, 400);
      } else {
      }
    },
  },
};
</script>
<style scoped >
.box-weight {
  width: 25%;
}
.demo-carousel {
  width: 100%;
  height: 100%;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 200px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
.ivu-layout-header {
  padding: 0 !important;
  height: 89px !important;
  background: rgba(17, 17, 17, 0.5) !important;
}
.ivu-menu-horizontal {
  height: 91px !important;
  line-height: 89px !important;
  /* background: rgba(17, 17, 17, 0.5) !important; */
}
.layout {
  /* border: 1px solid #d7dde4; */
  background: #f5f7f9;
  position: relative;
  border-radius: 4px;
  overflow: hidden;
}
.layout-logo {
  height: 30px;
  /* background: #5b6270; */
  border-radius: 3px;
  float: left;
  position: relative;
  top: 30px;
  left: 30px;
}
.layout-logo img {
  height: 44px;
  position: relative;
}

.layout-nav {
  width: 725px;
  margin: 0 auto;
  margin-right: 20px;
}
.layout-footer-center {
  text-align: center;
}
.ivu-layout-footer {
  padding: 0 !important;
}
.main-content {
  width: 80%;
  position: absolute;
  left: 9.5%;
  bottom: 1px;
  z-index: 9999;
  height: 140px;
  max-width: 1600px;
  /* margin-left: 12%; */
  background: rgba(0, 10, 29, 0.7);
  padding: 10px;
  /* margin-left: -600px; */
}
.main-content-text {
  display: table-cell;
  height: 120px;
  padding-top: 30px;
  padding-left: 1%;
  position: relative;
}
.main-content-text-left {
  display: table-cell;
  border-left: solid #3e4551 1px;
  height: 120px;
  padding-top: 30px;
  padding-left: 1%;
  position: relative;
  margin-bottom: 10px;
}
.main-content-size {
  width: 40%;
  margin-left: 20px;
}
.main-content-icon {
  color: #f85e22;
  font-size: 60px;
  float: left;
  font-style: normal;
  display: block;
  height: 60px;
  width: 60px;
  line-height: 60px;
  text-align: center;
  -webkit-font-smoothing: antialiased;
}
.main-content-size1 {
  color: #dddddd;
  font-size: 16px;
  line-height: 1;
  width: 116%;
}
.main-content-num {
  color: #fffefe;
  font-size: 34px;
  font-family: Helvetica;
  font-weight: bold;
  margin-top: 10px;
  display: block;
}
.Footer-text-left {
  font-size: 40px;
  color: #065fc3;
  display: inline-block;
  font-style: italic;
  margin-left: 23%;
  margin-top: 78px;
}
.Footer-text-right {
  width: 321px;
  display: inline-block;
  margin-left: 96px;
  /* color: #ffffff;
  position: absolute;
  top: 50%;
  transform: translateY(-50%); */
}
.Footer-layout-img {
  width: 100%;
  height: 67vh;
  background-image: url("../assets/bg.png");
}
.Footer-img {
  width: 1200px;
  position: absolute;
  top: 20%;
  left: 30%;
  margin-left: -600px;
}
.Footer-img1 {
  margin-left: 150px;
  width: 130px;
  height: 130px;
  border: 1px solid #fff;
}
.Footer-img-size {
  margin-left: 150px;
  margin-top: 20px;
  display: block;
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 12px;
}
.Footer-img-but {
  display: block;
  font-size: 14px;
  color: #ffffff;
  width: 130px;
  text-align: center;
  height: 32px;
  line-height: 32px;
  margin-top: 12px;
  border: solid #ffffff 1px;
  cursor: pointer;
  margin-left: 150px;
}

.Footer-img2 {
  margin-top: 40px;
  margin-left: 290px;
  width: 130px;
  height: 130px;
  border: 1px solid #fff;
}
.Footer-img2-size {
  margin-left: 290px;
  margin-top: 20px;
  display: block;
  font-size: 18px;
  color: #ffffff;
  margin-bottom: 12px;
}
.Footer-img2-but {
  display: block;
  font-size: 14px;
  color: #ffffff;
  width: 130px;
  text-align: center;
  height: 32px;
  line-height: 32px;
  margin-top: 12px;
  border: solid #ffffff 1px;
  cursor: pointer;
  margin-left: 290px;
}

.Footer-text-title {
  margin-top: 25px;
  font-size: 22px;
  margin-bottom: 10px;
  margin-left: -22px;
  color: #fff;
}
.Footer-img-app{
  margin-left: 10%;
  display: flex;
}
.app-div{
width: 150px;
height: 290px;
margin-left: 30px;
}
.app-img{
  width: 100%;
  height: 100%;
}
.opt {
  line-height: 2.2;
}
.opt-let {
  margin-left: -79px;
}
.opt-let2 {
  width: 400px;
  margin-left: -59px;
  display: inline-block;
}
.title {
  font-size: 16px;
  color: #b4c1cd;
  border-right: 1px #b4c1cd solid;
  padding-right: 15px;
}
.a-link {
  font-size: 16px;
  color: #ffffff;
  margin-left: 15px;
}
.a-link1 {
  font-size: 16px;
  color: #ffffff;
  margin-left: 14px;
}
.Line {
  margin-top: 40px;
  margin-bottom: 30px;
  /* border-bottom: 1px solid #fff; */
  z-index: 9999;
}
.LineClik {
  position: relative;
  bottom: 0px;
  left: 1px;
  width: 99.5%;
  height: 1px;
  background-color: #3f4955;
}
.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item-active,
.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-item:hover,
.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu-active,
.ivu-menu-dark.ivu-menu-horizontal .ivu-menu-submenu:hover {
  color: rgb(33, 195, 143);
}
.dix-tilei {
  position: absolute;
  left: 9.4%;
  bottom: 48%;
  z-index: 9899;
}
.tilei-css {
  font-size: 75px;
  font-weight: 600;
  color: #fff;
}
.tilei-css2 {
  font-size: 40px;
  color: #fff;
}
</style>


// WEBPACK FOOTER //
// src/pages/index.vue